// use this guard to hide elements based on certain condition.

interface VisibilityGuardProps {
  NotVisibleCondition: boolean;
  children: React.ReactNode;
}

export const VisibilityGuard = (VisibilityProps: VisibilityGuardProps) => {
  if (VisibilityProps.NotVisibleCondition) return null;
  else return <>{VisibilityProps.children}</>;
};
